import React from 'react';
import { useParams } from 'react-router-dom';

import RemoteAccessBuildingAudit from '@totem/components/services/remoteAccess/v2/buildingAudit/RemoteAccessBuildingAudit';
import RemoteAccessBuildingAuditContainer from '@totem/components/services/remoteAccess/v2/buildingAudit/RemoteAccessBuildingAuditContainer';
import RemoteAccessBuildingAuditPageTitle from '@totem/components/services/remoteAccess/v2/buildingAudit/RemoteAccessBuildingAuditPageTitle';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const RemoteAccessBuildingAuditPage = () => {
  const { buildingId } = useParams();

  return (
    <RemoteAccessBuildingAuditContainer buildingId={buildingId}>
      <ContentLayout pageTitle={<RemoteAccessBuildingAuditPageTitle />}>
        <IBCard isCovered title={<RemoteAccessBuildingAuditPageTitle />}>
          <RemoteAccessBuildingAudit />
        </IBCard>
      </ContentLayout>
    </RemoteAccessBuildingAuditContainer>
  );
};

export default RemoteAccessBuildingAuditPage;
